import { getLanguage } from './browser';
import { getPath } from './path';

export function getTextByPath(obj, path, defaultValue) {
    const language = getLanguage();
    const item = getPath(obj, path);

    if (!item) {
        return defaultValue;
    }

    return item[language] || item.en;
}

export function getText(id) {
    return getTextByPath(window.I18N, id, id);
}
